import { EMPTY_OBJ } from '@constants';

import useResourceList from './useResourceList';
import mutationFactory from './mutationFactory';
import useQuery from './useQuery';

import api from '..';

export const useVideosList = (queryVariables = {}, queryConfig = {}) => {
  const { data: videos = [], ...queryResult } = useResourceList(
    { name: 'videos', api: api.videos },
    queryVariables,
    queryConfig,
  );

  return {
    videos,
    latestVideos: queryResult.latestData,
    ...queryResult,
  };
};

export const useVideo = ({ id }, queryConfig = {}) => {
  const queryResult = useQuery(['video', { id }], api.videos.getById, {
    ...queryConfig,
    enabled: id,
  });

  return {
    video: queryResult.data || EMPTY_OBJ,
    ...queryResult,
  };
};

export const useVideosByIds = (ids, locale, queryConfig = {}) => {
  const queryResult = useQuery(['video-playlists', { ids }], api.videos.getByIds, {
    ...queryConfig,
    enabled: ids?.length > 0,
  });

  return {
    videos: queryResult.data || [],
    ...queryResult,
  };
};

const createMutation = mutationFactory({ invalidate: 'videos' });

export const useDeleteVideo = createMutation(api.videos.remove);

export const useCreateVideo = createMutation(api.videos.create);

export const useSaveVideo = createMutation(api.videos.save);

export const useUpdateVideo = createMutation(api.videos.update);

export const usePublishVideo = createMutation(api.videos.publish);

export const useUnpublishVideo = createMutation(api.videos.unpublish);
